import { isNil, negate } from 'lodash';

import { ReferralDiagnosis, ReferralVerificationFault } from '@dreryk/egabinet-referral-frontend-api';
import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { createSingleInterpolatedTranslationKey } from '@dreryk/react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import {
   diagnosesWithBodySideFormPart,
   DiagnosesWithBodySideFormPart,
} from '~libs.desktop.shared.visit-medical-documents.diagnoses';

import { referralTranslationKeys } from '../translations';

export const requiredValidator = (value?: { length: number }): boolean => {
   return Boolean(value && value.length);
};
export const dispatchElectronicReferralCodeSnackbarPositiveEvent = (code?: string): void => {
   const snackbarText = code
      ? createSingleInterpolatedTranslationKey(referralTranslationKeys.electronicReferralSent, 'code', code)
      : referralTranslationKeys.electronicReferralSentNoCode;
   return dispatchSnackbarPositiveEvent(snackbarText, {
      autoHideDelayInMs: false,
   });
};

export const getReferralVerificationResultErrorList = (error: ReferralVerificationFault): string[] =>
   (error.verificationResult?.errors
      ?.map((verificationError) => verificationError.description)
      .filter(negate(isNil)) as string[]) ?? [];

export const resolveDiagnosesFormPart = (
   diagnoses: DiagnosesWithBodySideFormPart | undefined,
   visitDiagnoses: VisitDiagnosis[] | undefined
): DiagnosesWithBodySideFormPart => {
   if (!diagnoses?.value?.length) {
      if (!visitDiagnoses?.length) {
         return diagnosesWithBodySideFormPart.createBean();
      }

      return diagnosesWithBodySideFormPart.createBean({
         value: visitDiagnoses.map((diagnosis) => ({
            code: diagnosis.icd10Code,
            name: diagnosis.name,
            main: diagnosis.main,
            bodySide: {
               left: false,
               right: false,
            },
         })),
      });
   }

   return diagnosesWithBodySideFormPart.createBean(diagnoses);
};

export const createReferralDiagnosesPayload = (
   diagnoses: DiagnosesWithBodySideFormPart['value']
): ReferralDiagnosis[] | undefined => {
   return diagnoses?.map((diagnosis) => ({
      icd10Code: diagnosis.code,
      leftSide: diagnosis.bodySide.left,
      rightSide: diagnosis.bodySide.right,
      main: diagnosis.main,
   }));
};
